export default {"src":"/_next/static/image/public/images/ic_twitter.4cacb29dd475544f386d7fc578e1d944.svg","height":36,"width":36};